import { render, staticRenderFns } from "./PreviewEmail.vue?vue&type=template&id=53d23c13&scoped=true"
import script from "./PreviewEmail.vue?vue&type=script&lang=js"
export * from "./PreviewEmail.vue?vue&type=script&lang=js"
import style0 from "./PreviewEmail.vue?vue&type=style&index=0&id=53d23c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d23c13",
  null
  
)

export default component.exports